import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Link, useLocation, useParams } from "react-router-dom";
import file from "../../../assets/files/file.docx";
import AppBreadcrumb from "../../../components/template/BreadCrumb/AppBreadcrumb";
import MetaInformation from "../../../utils/meta/MetaInformation";
import { findActiveTab } from "../../accessories/AccessoriesInfo/findActiveTab";
import "../../accessories/AccessoriesInfo/AccessoriesInfo.scss";
import { centralGasesData } from "../centralGasesData";

const CentralGasInfo = () => {
  const [activeTab, setActiveTab] = useState("description");
  const [activeCentralGas, setActiveCentralGas] = useState([]);
  const [activeImage, setActiveImage] = useState("");
  const location = useLocation().state;
  const params = useParams().id;

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    setActiveTab("description");

    setActiveCentralGas(
      location.filteredArray.filter((state) => state.title === location.title)
    );

    if (params === "medical-air-plant") {
      setActiveImage(centralGasesData[0].instruments[4].image);
    }
    if (params === "avsu") {
      setActiveImage(centralGasesData[0].instruments[3].image);
    }
  }, [params]);

  const activeHandler = (event) => {
    setActiveTab(findActiveTab(event.target.innerText));
  };

  const description = (state) => {
    if (params === "british-standard-terminal-units") {
      return (
        <>
          {Array.isArray(state.description) &&
            state.description?.map((state, index) => (
              <p className={index === 0 ? "mt-3" : ""} key={index}>
                {state}
              </p>
            ))}
        </>
      );
    } else {
      return (
        <>
          <p className="mt-3">{state.description?.describe}</p>
          <ul className="mt-3">
            {state.description?.list1?.map((state, index) => (
              <li key={index}>{state}</li>
            ))}
          </ul>
        </>
      );
    }
  };
  const characteristics = (state) => {
    if (params === "piston-type-regulators") {
      return (
        <>
          <p className="mt-3">{state.characteristics?.charac}</p>
          <h6>{state.characteristics?.heading1}</h6>
          <ul className="mt-2">
            {state.characteristics?.list1?.map((state, index) => (
              <li key={index}>{state}</li>
            ))}
          </ul>
          <h6>{state.characteristics?.heading2}</h6>
          <ul className="mt-2">
            {state.characteristics?.list2?.map((state, index) => (
              <li key={index}>{state}</li>
            ))}
          </ul>
        </>
      );
    } else {
      return (
        <ul className="mt-3">
          {state.characteristics?.map((state, index) => (
            <li key={index}>{state}</li>
          ))}
        </ul>
      );
    }
  };

  const medicalAirPLant = (state) => {
    return (
      <aside className="d-flex gap-2">
        <Card
          className={activeImage === state.image && "ActiveImage"}
          onClick={() => setActiveImage(state.image)}
        >
          <img src={state.image} alt={state.title} />
        </Card>
        <Card
          className={activeImage === state.image2 && "ActiveImage"}
          onClick={() => setActiveImage(state.image2)}
        >
          <img src={state.image2} alt={state.title} />
        </Card>
      </aside>
    );
  };

  return (
    <>
      <MetaInformation
        title={`${location.title} - HERZMANN`}
        name="Central Gas info route"
        content={`Showing details of ${location.title}`}
      />
      <AppBreadcrumb />
      <main className="Single_Accessories_Main">
        {activeCentralGas?.map((state, index) => {
          return (
            <Container fluid="lg" key={index}>
              <Row>
                <Col className="p-3">
                  <article>
                    <div className="d-flex justify-content-center flex-row gap-3 flex-md-column align-items-start">
                      <Card className="d-flex justify-content-center align-items-center">
                        {params === "medical-air-plant" || params === "avsu" ? (
                          <img
                            src={activeImage}
                            alt={`${state.title} image`}
                            className={
                              params === "critical-area-bed-head-units" ||
                              params === "patient-bed-head-units"
                                ? "bed-units"
                                : ""
                            }
                          />
                        ) : (
                          <img
                            src={state.image}
                            alt={`${state.title} image`}
                            className={
                              params === "critical-area-bed-head-units" ||
                              params === "patient-bed-head-units"
                                ? "bed-units"
                                : ""
                            }
                          />
                        )}
                      </Card>
                      {params === "medical-air-plant" && medicalAirPLant(state)}
                      {params === "avsu" && medicalAirPLant(state)}
                    </div>
                    <div>
                      <h4>{state.title}</h4>
                      {state.heading && <h5>{state.heading}</h5>}
                      <p>{state.working}</p>
                      {/* file shoulbe be import and its name should be added as to={file-name} or url should be placed in to for download */}
                      <Link
                        target="_blank"
                        rel="noopener noreferrer"
                        to={file}
                        download
                      >
                        Download
                      </Link>
                    </div>
                  </article>
                </Col>
              </Row>
              <Row className="mt-4">
                <Col className="p-3">
                  <span>
                    <button
                      value="description"
                      className={activeTab === "description" ? "Active" : ""}
                      onClick={activeHandler}
                    >
                      Description
                    </button>
                    <button
                      value="characteristics"
                      className={
                        activeTab === "characteristics" ? "Active" : ""
                      }
                      onClick={activeHandler}
                    >
                      Characteristics
                    </button>
                  </span>

                  {activeTab === "description" && description(state)}
                  {activeTab === "characteristics" && characteristics(state)}
                </Col>
              </Row>
            </Container>
          );
        })}
      </main>
    </>
  );
};

export default CentralGasInfo;
